interface DataAttributes {
  [key: `data-${string}`]: string | undefined;
}

function isDataAttributeKey(key: string): key is `data-${string}` {
  return key.startsWith("data-");
}

function pickDataAttributes(source: object): DataAttributes {
  const picked: DataAttributes = {};
  for (const key of Object.keys(source)) {
    if (isDataAttributeKey(key)) picked[key] = (source as DataAttributes)[key];
  }
  return picked;
}

function omitDataAttributes<T extends object>(
  source: T
): Omit<T, `data-${string}`> {
  return Object.fromEntries(
    Object.entries(source).filter(([key]) => !isDataAttributeKey(key))
  ) as Omit<T, `data-${string}`>;
}

function deriveTrackName(source: object, suffix: string): DataAttributes {
  const name = pickDataAttributes(source)["data-track-name"];
  if (!name) return {};
  return { "data-track-name": `${name}${suffix}` };
}

export { deriveTrackName, omitDataAttributes, pickDataAttributes };
export type { DataAttributes };
